import { render, staticRenderFns } from "./dutyType.vue?vue&type=template&id=f8beacf0&scoped=true"
import script from "./dutyType.vue?vue&type=script&lang=js"
export * from "./dutyType.vue?vue&type=script&lang=js"
import style0 from "./dutyType.vue?vue&type=style&index=0&id=f8beacf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8beacf0",
  null
  
)

export default component.exports